// Browsers use different messages when a deferred module is missing after an
// app release, or cannot be downloaded. Do not treat ordinary fetch failures
// or application exceptions as module failures.
const moduleLoadMessages = [
    /^Failed to fetch dynamically imported module(?:\s*:|$)/i,
    /^Importing a module script failed\.?$/i,
    /^error loading dynamically imported module(?:\s*:|$)/i,
    /^Unable to preload CSS for /,
];

export function isModuleLoadError(error) {
    const message = typeof error?.message === 'string' ? error.message : '';
    return moduleLoadMessages.some((pattern) => pattern.test(message));
}
